import type { Ref } from 'vue'

const CACHE_KEY = `breeze::helm:queryCache`

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const HELM_QUERY_KEYS: Record<string, any> = {
    ipAllowlist: (page: Ref<number>, search: Ref<string>) => [`ipAllowlist`, page, search],
    emailSuppressions: (email: Ref<string>, types?: Ref<string[] | undefined>) => [`emailSuppressions`, email, types],
    smsBlacklistStatus: (number: Ref<string>) => [`smsBlacklist`, number],
    organizationFavorites: [`organizations`, `favorites`],
    countries: [`countries`],
    hubFeatureFlags: [`features`, `hub-flags`],
    organizationGivingSettings: (oid: number) => [`organizations`, oid, `giving-settings`],
    organizationSmsSettings: (oid: number) => [`organizations`, oid, `sms-settings`],
    organizationEmailSettings: (oid: number) => [`organizations`, oid, `email-settings`],
    organizationMessagingCounts: (oid: number) => [`organizations`, oid, `messaging-counts`],
    featureDisabledOrganizations: (id: number, page: Ref<number>) => [`features`, id, `organizations`, page],
    appConfig: [`appConfig`],
    integrations: [`integrations`],
    allFeatures: [`features`, `all`],
    features: (page?: Ref<number>, search?: Ref<string>) => (page ? [`features`, page, search] : [`features`]),
    feature: (id: number) => [`features`, id],
    navigation: [`navigation`],
    globalMessageTemplates: [`globalMessageTemplates`],
    globalMessageTemplate: (id: number) => [...HELM_QUERY_KEYS.globalMessageTemplates, id],
    globalMessageTemplatePreview: (id: number) => [...HELM_QUERY_KEYS.globalMessageTemplates, id, `preview`],
    me: [`me`],
    loginConfig: [`loginConfig`],
    organizations: [`organizations`],
    cancellationStatistics: [`cancellationStatistics`],
    getCancellationFeedbacks: [`getCancellationFeedbacks`],
    updateCancellationFeedback: (id: number) => [`updateCancellationFeedback`, id],
    organizationMdsMigrations: (oid: number) => [`organizations`, oid, `mds-migrations`],
    organizationFeatures: (oid: number) => [`organizations`, oid, `features`],
    organizationFeature: (oid: number, id: number) => [`organizations`, oid, `features`, id],
    organizationSearch: (page: Ref<number>, search: Ref<string>, status: Ref<number | undefined>) => [
        ...HELM_QUERY_KEYS.organizations,
        page,
        search,
        status ?? null
    ],
    organizationUsers: (oid: number) => [`organizations`, oid, `users`],
    organizationUser: (oid: number, id: number) => [`organizations`, oid, `user`, id],
    organization: (id: number) => [`organization`, id],
    retryableJobs: [`retryableJobs`],
    retryableJob: (id: number) => [...HELM_QUERY_KEYS.retryableJobs, id],
    users: [`users`],
    user: (id: number) => [`user`, id],
    roles: [`roles`],
    role: (id: number) => [...HELM_QUERY_KEYS.roles, id],
    helmTenant: [`tenants`, `helm`],
    tenants: [`tenants`],
    tenant: (id: number) => [`tenant`, id],
    samlMappings: (tenant: number) => [`tenant`, tenant, `mappings`],
    samlMapping: (tenant: number, id: number) => [`tenant`, tenant, `mapping`, id],
    metrics: [`metrics`],
    metricsData: (metrics: string[], startDate?: string, endDate?: string, intervalMinutes?: number) => [
        `metrics`,
        `data`,
        metrics,
        startDate ?? null,
        endDate ?? null,
        intervalMinutes ?? null
    ],
    messagingScheduled: [`messaging`, `scheduled`],
    messagingRuns: [`messaging`, `runs`],
    metricDimensionData: (metric: string, dimension: string, startDate?: string, endDate?: string) => [
        `metrics`,
        `data`,
        metric,
        `dimension`,
        dimension,
        startDate ?? null,
        endDate ?? null
    ],
    metricDimensionNames: (metric: string, startDate?: string) => [`metrics`, `dimensions`, metric, startDate ?? null],
    dashboard: [`dashboard`]
}

export { CACHE_KEY, HELM_QUERY_KEYS }
